import { useFormik } from "formik";
import { ModalComponent } from "..";
import { fileUploadSchema } from "../../../validationSchema";
import { FileUploadInput } from "../../inputs/fileUploadInput";

export const FileUploadModal = ({
  modalOpen,
  handleModalClose,
  onSuccess,
  loading = false,
}: {
  modalOpen: boolean;
  handleModalClose: () => void;
  onSuccess: (data: { file: File[]; reset: () => void }) => void;
  loading?: boolean;
}) => {
  const reset = () => {
    resetForm();
    handleModalClose();
  };

  const { values, errors, setFieldValue, isValid, resetForm, handleSubmit } =
    useFormik({
      initialValues: {
        file: undefined,
      },
      validationSchema: fileUploadSchema,
      onSubmit: async (vals) => {
        onSuccess({
          file: [vals.file as unknown as File],
          reset: () => {
            reset();
          },
        });
        return;
      },
    });

  return (
    <>
      <ModalComponent
        isModalOpen={modalOpen}
        onModalClose={() => {
          reset();
        }}
        title="Upload File"
        hasButtons
        isLoading={loading}
        isProceedDisabled={!isValid || loading}
        proceedButtonText="Proceed"
        onProceedClick={() => {
          handleSubmit();
        }}
        hasCancelButton={false}
        childrenClassName=""
        topTitle
      >
        <FileUploadInput
          title={"proof of payment"}
          maxNumberOfFiles={1}
          handleChange={(files) => {
            setFieldValue("file", files[0]);
          }}
          selectedFiles={values.file ? [values.file] : undefined}
          errors={errors?.file ? errors?.file : ""}
          accept="image/*,.pdf"
        />
      </ModalComponent>
    </>
  );
};
